import { useTranslation } from 'react-i18next';

export const useStatusBadge = () => {
    const { t } = useTranslation();

    const statusBadge = (item, column) => {
        if (column.key === 'active' || column.key === 'hasTranslations' || column.key === 'translated') {
            return (
                <span className={`status-badge ${item[column.key] ? 'active' : 'inactive'}`}>
                    {t('common.' + (item[column.key] ? 'yes' : 'no'))}
                </span>
            );
        }
        return item[column.key];
    };

    return { statusBadge };
};
